/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { ArrowDropDown, ArrowDropUp, ArrowDropUpOutlined, ArrowDropUpTwoTone, Poll } from '@mui/icons-material';
import { Box, Collapse, Divider, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { useTranslation } from 'react-i18next';

interface IProps {
    groupType: string,
    //rows: ISourceDocumentModel[] | null,
    //errors: string[],
    //limitPerPage: number,
    //totalItems: number,
    //loader: boolean,
    //changePage: (page: number) => void
    //sortItem: (sortItem: IFileSortItem | null) => void,
}

const TableCashRegister = (props: IProps): JSX.Element => {

    const theme = useTheme();

    const { t, i18n } = useTranslation();

    function CreateTableHeaderSegment() {

        return <>
            <TableRow >
                <TableCell align="right">{t("reports.invoiceNo")}</TableCell>
                <TableCell align="right">{t("reports.voucherNo")}</TableCell>
                <TableCell align="right">{t("reports.voucherDate")}</TableCell>
                <TableCell align="right">{t("reports.standardText")}</TableCell>
                <TableCell align="right">{t("search.amount")}</TableCell>
                <TableCell align="right">{t("reports.outstanding")}</TableCell>
                <TableCell align="right">{t("search.dueDate")}</TableCell>
                <TableCell align="right">{t("reports.remitted")}</TableCell>
            </TableRow>
        </>
    }
    function CreateTableBodySegment() {

        return <>
            <TableRow >
                <TableCell align="right">Test</TableCell>
                <TableCell align="right">Test</TableCell>
                <TableCell align="right">Test</TableCell>
                <TableCell align="right">Test</TableCell>
                <TableCell align="right">Test</TableCell>
                <TableCell align="right">Test</TableCell>
                <TableCell align="right">Test</TableCell>
                <TableCell align="right">Test</TableCell>
            </TableRow>
        </>
    }

    return <TableContainer sx={{ height: "100%" }}>
        <Table size="small" aria-label="collapsible table" stickyHeader sx={{ width: "100%", height: "100%" }}>
            <TableHead>
                <TableRow>
                    {CreateTableHeaderSegment()}
                </TableRow>
            </TableHead>
            <TableBody>
                {CreateTableBodySegment()}
            </TableBody>
        </Table>
    </TableContainer>

    
}

export default TableCashRegister;